export enum FilterFieldsKeys {
  CreatedDateFrom = 'createdDateFrom',
  CreatedDateTo = 'createdDateTo',
  LastModifiedTimeFrom = 'lastModifiedTimeFrom',
  LastModifiedTimeTo = 'lastModifiedTimeTo',

  ProgramName = 'programName',
  ReferralCode = 'referralCode',
  DistributorAgentId = 'distributorAgentId',
  IdvMethod = 'idvMethod',
  ReferralCodeStatus = 'referralCodeStatus',
  VipLevel = 'vipLevel',
  ConsumedSupportedSystem = 'consumedSupportedSystem',
  Source = 'source',
  KycLevel = 'kycLevel',
}

export interface FilterFields {
  [FilterFieldsKeys.CreatedDateFrom]: string;
  [FilterFieldsKeys.CreatedDateTo]: string;
  [FilterFieldsKeys.LastModifiedTimeFrom]: string;
  [FilterFieldsKeys.LastModifiedTimeTo]: string;
  [FilterFieldsKeys.ProgramName]: string;
  [FilterFieldsKeys.ReferralCode]: string;
  [FilterFieldsKeys.DistributorAgentId]: string;
  [FilterFieldsKeys.IdvMethod]: string;
  [FilterFieldsKeys.ReferralCodeStatus]: string;
  [FilterFieldsKeys.VipLevel]: string;
  [FilterFieldsKeys.ConsumedSupportedSystem]: string[];
  [FilterFieldsKeys.Source]: string;
  [FilterFieldsKeys.KycLevel]: string;
}
